





	// @ts-ignore
    import _ from './MSortListBtn.ts'; export default _;
